import _ from "lodash";

export default (state = {}, action) => {
  switch(action.type) {
    case 'SET_NETWORK_ERROR': {
    const exception = _.get(action, 'error.result.error.Task.errors.taskType[0]', '')
      if (exception) {
        return {
          ...state
        };
      }
      return {
        ...state,
        networkError: action.error,
        operation: state.operation ? [...state.operation, action.operation] : [action.operation]}
      }
    case 'SET_GRAPHQL_ERRORS':
      return {
        ...state,
        graphQLErrors: action.error,
        operation: state.operation ? [...state.operation, action.operation] : [action.operation]}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/errors-reducer.js